import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { designSystem } from '@yola/ws-ui';
import withFeatureFlags from 'yola-editor/src/js/modules/feature-flags/hoc/with-feature-flags';

const { ActionButton } = designSystem;

const defaultAviabilityChecker = () => true;

function AiWriterTrigger({
  elementId = '',
  getContext,
  width,
  aviabilityChecker = defaultAviabilityChecker,
  onClick = Function.prototype,
  onMouseDown = Function.prototype,
  onTouchStart = Function.prototype,
  onUnmount = Function.prototype,
}) {
  // eslint-disable-next-line yola/react-hooks/exhaustive-deps
  useEffect(() => () => onUnmount(elementId), []);

  if (!elementId) {
    return null;
  }

  const { aiWriteTriggerRef, onAiWriteTriggerClick } = getContext();

  const handleClick = () => {
    onClick();
    onAiWriteTriggerClick();
  };

  const handleMouseDown = (e) => {
    onMouseDown(elementId);

    // We need this to stop the context menu from hiding
    // This gives us the ability to control the display/hiding of the ai rewrite context menu
    e.stopPropagation();
  };

  const handleTouchStart = () => {
    onTouchStart(elementId);
  };

  return (
    <div className="ws-ai-writer-trigger" style={{ width: `${width}px` }} ref={aiWriteTriggerRef}>
      <ActionButton
        appearance="accent"
        format="solid-white"
        fullWidth
        rounded={false}
        label="Writer"
        iconGlyph="ai"
        disabled={!aviabilityChecker()}
        onClick={handleClick}
        onMouseDown={handleMouseDown}
        onTouchStart={handleTouchStart}
      />
    </div>
  );
}

AiWriterTrigger.propTypes = {
  elementId: PropTypes.string,
  getContext: PropTypes.func.isRequired,
  width: PropTypes.number.isRequired,
  aviabilityChecker: PropTypes.func,
  onClick: PropTypes.func,
  onMouseDown: PropTypes.func,
  onTouchStart: PropTypes.func,
  onUnmount: PropTypes.func,
};

// to ensure that feature flags is loaded, they are used in control `matches` function
export default withFeatureFlags([
  'ai_text_assistant_rewrite',
  'ai_text_assistant_write',
  'ai_text_assistant_rewrite_v2',
])(AiWriterTrigger);
